import { render, staticRenderFns } from "./ParagraphIframeYoutube.vue?vue&type=template&id=6682389e&"
import script from "./ParagraphIframeYoutube.vue?vue&type=script&lang=js&"
export * from "./ParagraphIframeYoutube.vue?vue&type=script&lang=js&"
import style0 from "./ParagraphIframeYoutube.vue?vue&type=style&index=0&id=6682389e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports